export function isPCAdapterActive(): boolean {
  return typeof document !== 'undefined' && document.body.classList.contains('is-pc');
}
